/**
 * Единое правило: сначала подразделение (тип, sort_order, имя), внутри — алфавит команды (ru).
 * Поля с бэка: department_type, department_sort_order или sort_order, department_name, name, team_name, team.
 */

const typeRank = (dt) => ((dt || '').trim() === 'Производственное' ? 0 : 1)

export function compareTeamsByDepartmentAndName(a, b) {
  const ta = typeRank(a?.department_type)
  const tb = typeRank(b?.department_type)
  if (ta !== tb) return ta - tb

  const soA = Number(a?.department_sort_order ?? a?.sort_order ?? 0)
  const soB = Number(b?.department_sort_order ?? b?.sort_order ?? 0)
  if (soA !== soB) return soA - soB

  const dnA = String(a?.department_name || '').toLocaleLowerCase('ru')
  const dnB = String(b?.department_name || '').toLocaleLowerCase('ru')
  const dcmp = dnA.localeCompare(dnB, 'ru')
  if (dcmp !== 0) return dcmp

  const tnA = String(a?.team_name || a?.name || a?.team || '').toLocaleLowerCase('ru')
  const tnB = String(b?.team_name || b?.name || b?.team || '').toLocaleLowerCase('ru')
  return tnA.localeCompare(tnB, 'ru')
}

export function sortTeamsByDepartmentAndName(teams) {
  if (!teams?.length) return teams || []
  return [...teams].sort(compareTeamsByDepartmentAndName)
}
